import jwt_decode from 'jwt-decode'
import Vue from 'vue'
import VueRouter from 'vue-router'
import Cookie from 'js-cookie'
import Home from '../views/Home'
import Character from '../views/Character'
import Gallery from '../views/Gallery'
import Image from '../views/Image'
/* import Upload from '../views/Upload'
import Register from '../views/Register'
import Login from '../views/Login'
import Account from '../views/Account'
import TermsOfService from '../views/TermsOfService'
import PrivacyPolicy from '../views/PrivacyPolicy' */
import Over18 from '../views/Over18'
import NotFound from '../views/NotFound'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      requires18: true
    }
  },
  {
    path: '/gallery',
    name: 'Gallery',
    component: Gallery,
    meta: {
      requires18: true
    }
  },
  {
    path: '/gallery/:id',
    name: 'Character',
    component: Character,
    meta: {
      requires18: true
    }
  },
  {
    path: '/image/:name',
    name: 'Image',
    component: Image,
    meta: {
      requires18: true
    }
  },
  /* {
    path: '/upload',
    name: 'Upload',
    component: Upload,
    meta: {
      requires18: true
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      requires18: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      requires18: true
    }
  },
  {
    path: '/account',
    name: 'Account',
    component: Account,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/terms-of-service',
    name: 'TermsOfService',
    component: TermsOfService
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  }, */
  {
    path: '/not-found',
    name: 'NotFound',
    component: NotFound
  },
  {
    path: '*',
    redirect: '/not-found'
  }
]

if (process.env.VUE_APP_OVER_18) {
  routes.push({
    path: '/over18',
    name: 'Over18',
    component: Over18
  })
}

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const token = Cookie.get('authentication')

    if (token && jwt_decode(token)) {
      next()
    } else {
      next({
        name: 'Login'
      })
    }
  } else {
    next()
  }
})

if (process.env.VUE_APP_OVER_18) {
  router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requires18)) {
      if (Cookie.get('is18')) {
        next()
      } else {
        next({
          name: 'Over18',
          params: {
            nextUrl: to.fullPath
          }
        })
      }
    } else {
      next()
    }
  })
}

export default router
